import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-changfangxing",
  "use": "icon-changfangxing-usage",
  "viewBox": "0 0 1740 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1740 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-changfangxing\"><path fill=\"#515151\" d=\"M0 0h1740.8v1024H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol